module.exports = __webpack_public_path__ + "open-sans-v17-latin-700.woff2?0edb76284a7a0f8db4665b560ee2b48f";